// extracted by mini-css-extract-plugin
export default {"wrapper":"f4-z","play":"g4-z"};